import React, { useState } from "react";
import { GoPlus } from "react-icons/go";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import styled from "styled-components";
import { useContext } from "react";
import { PageContext } from "../../Context/PageContext";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { useDispatch } from "react-redux";
import { createNewForm } from "../../Redux/Reducer/FormSlices";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchData } from "../../Api/FormApis";
import ReactModal from "react-modal";
import UserResponsePage from "../../Pages/UserResponsePage";

const CreateForm = () => {
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [,] = useState(false);
  const { setLink, setShowShearModel } = useContext(PageContext);
  const [openPreview, setOpenPreview] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formId = useParams();
  const location = useLocation().pathname;

  const form = useSelector((state) => state.form.form);
  const handelShear = () => {
    fetchData(form, dispatch, createNewForm);
    setShowShearModel(true);
    const baseUrl = "http://localhost:3000/api";
    const uniqueToken = uuidv4();
    setLink(`${baseUrl}/${form._id}?token=${uniqueToken}`);
  };

  const handleSave = () => {
    fetchData(form, dispatch, createNewForm);
    navigate('/forms/list');
  };

  const handelGetFormById = () => {
    const URl = process.env.REACT_APP_API;
    axios
      .get(`${URl}/forms/${formId.formId}`)
      .then((form) => {
        dispatch(createNewForm(form.data.form));
        navigate(`/create-form/${form.data.form._id}/question`);
        console.log(form.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const dataView = `/create-form/${formId.formId}/responses/dataview`;
  const tableView = `/create-form/${formId.formId}/responses/tableview`;
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "15px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      height: "80%",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
      padding: "0px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
      zIndex: "999"
    },
  };

  return (
    <>
      <ReactModal
        isOpen={openPreview}
        onRequestClose={() => setOpenPreview(false)}
        style={customStyles}
      >
        <UserResponsePage />
      </ReactModal>
      <TaskPageContainer>
        <div className="taskpage-topbar">
          <div className="task-tabs">
            <div
              className="task-tab"
              style={{
                color:
                  location === `/create-form/${formId.formId}/question`
                    ? "#1B51BB"
                    : "#8493B2",
                fontWeight:
                  location === `/create-form/${formId.formId}/question`
                    ? "600"
                    : "500",
              }}
              onClick={() => {
                handelGetFormById();
              }}
            >
              Question
              {location === `/create-form/${formId.formId}/question` && (
                <div className="form-underline"></div>
              )}
            </div>
            <div
              className="task-tab"
              style={{
                color:
                  location === dataView || location === tableView
                    ? "#1B51BB"
                    : "#8493B2",
                fontWeight:
                  location === dataView || location === tableView
                    ? "600"
                    : "500",
              }}
              onClick={() => {
                navigate(`/create-form/${formId.formId}/responses/dataview`);
              }}
            >
              Responses
              {location === dataView || location === tableView ? (
                <div className="form-underline"></div>
              ) : (
                ""
              )}
            </div>
            <div
              className="task-tab"
              style={{
                color:
                  location === `/create-form/${formId.formId}/settings`
                    ? "#1B51BB"
                    : "#8493B2",
                fontWeight:
                  location === `/create-form/${formId.formId}/settings`
                    ? "600"
                    : "500",
              }}
              onClick={() => {
                navigate(
                  `/create-form/${formId.formId}/settings/generalsetting`
                );
              }}
            >
              Settings
              {location === `/create-form/${formId.formId}/settings` && (
                <div className="form-underline"></div>
              )}
            </div>
          </div>

          <div className="taskCTA">
            <div className="create- Responses-based-time">
              <div
                className="date-range"
                onClick={() => setOpenFilterModal(!openFilterModal)}
              >
                <MdOutlineRemoveRedEye color="rgba(27, 81, 187, 0.5)" />
                <div className="filter-text" onClick={() => setOpenPreview(true)}>Preview</div>
              </div>
              {openFilterModal && <div className=" Responses-filter-box"></div>}
            </div>
            <div className="create-task" onClick={() => handleSave()}>
              <GoPlus
                color="#ffffff"
                style={{ width: "17px", height: "17px" }}
              />
              <div className="btn-text">Save</div>
            </div>
            <div className="create-task" onClick={() => handelShear()}>
              <GoPlus
                color="#ffffff"
                style={{ width: "17px", height: "17px" }}
              />
              <div className="btn-text">Share</div>
            </div>
          </div>
        </div>

        <Outlet />
      </TaskPageContainer>
    </>
  );
};

export default CreateForm;
const TaskPageContainer = styled.div`
  /* width: calc(100% - 5.625rem);
  min-height: calc(100vh - 0rem);
  background-color: green;
  background-color: #eff2f4;
  position: absolute;
  top: 5.938rem;
  left: 5.625rem; */
  background-color: rgba(239, 242, 244, 1);
`;
